<template>
<div>
	<p id="PageTopBtn"><a href="#wrap"><img :src="baseUrl + '_img/arrow_up.png'" alt="上へ"></a></p>
	<header class="pc">
		<nav class="global-nav">
			<ul class="g-nav">
				<li class="g-nav__separator">|</li>
				<li class="g-nav__link"><a href="/">ホーム</a></li>
				<li class="g-nav__separator">|</li>
				<li class="g-nav__link">
					<a href="/company/aboutus.html">企業情報</a>
					<ul>
						<li><a href="/company/aboutus.html">ごあいさつ</a></li>
						<li><a href="/company/outline.html">会社概要</a></li>
						<li><a href="/company/office.html">事業所紹介</a></li>
						<li><a href="/company/download.html">指定様式ダウンロード</a></li>
						<li><a href="/company/privacy.html">個人情報保護基本方針</a></li>
					</ul>
				</li>
				<li class="g-nav__separator">|</li>
				<li class="g-nav__link">
					<a href="/business">事業紹介</a>
					<ul>
						<li><a href="/business/merit.html">レンタルのメリット</a></li>
						<li><a href="/business/process.html">手続きの流れ</a></li>
						<li><a href="/business/topics.html">チガレンTopics！</a></li>
						<!--<li><a href="#">中古機械販売</a></li>-->
					</ul>
				</li>
				<li class="g-nav__separator">|</li>
				<li class="g-nav__logo"><a href="/"></a></li>
				<li class="g-nav__separator">|</li>
				<li class="g-nav__link"><a href="/catalog/">商品カタログ</a></li>
				<li class="g-nav__separator">|</li>
				<li class="g-nav__link">
					<a href="/recruit/">採用情報</a>
					<ul>
						<li><a href="/recruit/freshers_menu.html">新卒採用</a></li>
						<li><a href="/recruit/career_menu.html">キャリア採用</a></li>
					</ul>
				</li>
				<li class="g-nav__separator">|</li>
				<li class="g-nav__link"><a href="/business/topics.html">チガレンTopics!</a></li>
				<li class="g-nav__separator">|</li>
			</ul>
		</nav>
	</header>
	<header class="sp">
  <div id="nav-drawer">
    <input id="nav-input" type="checkbox" class="nav-unshown">
      <label id="nav-open" for="nav-input"><span></span></label>
      <label class="nav-unshown" id="nav-close" for="nav-input"></label>

      <div id="nav-content" class="sp-menu">

					<label for="menu_bar01"><a href="/">ホーム</a></label>
					<label for="menu_bar02">企業情報</label>
          <input type="checkbox" id="menu_bar02" class="accordion" />
          <ul id="links02">
						<li><a href="/company/aboutus.html">ごあいさつ</a></li>
						<li><a href="/company/outline.html">会社概要</a></li>
						<li><a href="/company/office.html">事業所紹介</a></li>
						<li><a href="/company/privacy.html">個人情報保護基本方針</a></li>
          </ul>
					<label for="menu_bar03">事業紹介</label>
          <input type="checkbox" id="menu_bar03" class="accordion" />
          <ul id="links03">
						<li><a href="/business">事業紹介</a></li>
						<li><a href="/business/merit.html">レンタルのメリット</a></li>
						<li><a href="/business/process.html">手続きの流れ</a></li>
						<li><a href="/company/download.html">指定様式ダウンロード</a></li>
						<li><a href="/business/topics.html">チガレンTopics！</a></li>
          </ul>
					<label for="menu_bar04"><a href="/catalog/">商品カタログ</a></label>
					<label for="menu_bar05">採用情報</label>
          <input type="checkbox" id="menu_bar05" class="accordion" />
          <ul id="links05">
						<li><a href="/recruit/freshers_menu.html">新卒採用</a></li>
						<li><a href="/recruit/career_menu.html">キャリア採用</a></li>
          </ul>
					<label for="menu_bar06"><a href="/business/topics.html">チガレンTopics!</a></label>

				</div>
     </div>
	</header>
<!-- Global site tag (gtag.js) - Google Analytics -->
<!-- script async src="https://www.googletagmanager.com/gtag/js?id=UA-139870383-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-139870383-1');
</script -->
</div>
</template>

<script>
  export default {
    data: function (){
      return {
        baseUrl: process.env.BASE_URL,
        menu : {
          show: false
        }
      }
    },
    methods: {
      toggleList: function (menu){
        menu.show = !menu.show
      },
      mobileShow: function (status){
        var mq_mode = this.$mq
        console.log("vue-mq",this.$mq)
        if(mq_mode==='pc'){
          return true
        }else{
          return status
        }
      }
    }
  }
</script>
